import React, { ReactNode } from "react"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IErrorModel } from "../../../types/error/IErrorModel"

export const ModalPopUp: React.FC<{
  message: IModalMessage | null
  close: () => void
  error?: IErrorModel
  actionButton?: ReactNode
}> = ({ message, close, error, actionButton }) => {
  if (message && (message.text || (error && error.fieldErrors.length === 0))) {
    return (
      <section className="popup-forms index-top" id="error-popup">
        <div className="container-popup-forms">
          <button className="close-btn-card" id="password-close" onClick={close} />
          <div className="popup-card">
            <h4 className="heading-chapter">{message.title}</h4>
            {message.h1 ? <p className="ui-heading">{message.h1}</p> : <></>}
            <p>{error && error.fieldErrors.length === 0 ? error.message : message.text}</p>
            <div className="flex-row-24">
              <button className="btn" id="error-close" onClick={close}>
                Понятно
              </button>
              {actionButton}
            </div>
          </div>
        </div>
      </section>
    )
  } else {
    return <></>
  }
}
